/* eslint-disable no-useless-escape */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
// Swiper js
import Swiper from "swiper";
import { Navigation, Pagination, Mousewheel, Autoplay, Thumbs, EffectFade } from "swiper/modules";

Swiper.use([Navigation, Pagination, Mousewheel, Autoplay, Thumbs, EffectFade]);

window.Swiper = Swiper;

// Swiper css
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/mousewheel";
import "swiper/css/autoplay";
import "swiper/css/thumbs";
import "swiper/css/effect-fade";

// Components
import Components from "barcelo-components";
import BarceloComponents from "barcelo-components-init";

const crossOriginURLS = /booking.barcelo.com|reservation.barcelo.com/;

//----------------------------------------------------------------//

bcl.u.getLongCacheKey = function () {
  const prefix = ".lc-";
  const suffix = "-lc.min.js";

  const resources = performance.getEntriesByType("resource");

  const clientLibsUrl = resources.find((resource) => {
    return resource.name.includes(prefix) && resource.name.includes(suffix);
  });

  if (!clientLibsUrl) {
    return "";
  }

  const url = clientLibsUrl.name;

  const startIndex = url.indexOf(prefix);
  const endIndex = url.indexOf(suffix, startIndex);

  if (startIndex === -1 || endIndex === -1) {
    console.error("Failed to extract cache ID from URL.");
    return "";
  }

  const cacheKey = url.substring(startIndex + prefix.length, endIndex);

  return cacheKey;
};

//------- Load External Script Function -------//

bcl.u.importScript = function (url, globalName) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = url;
    script.type = "text/javascript";
    script.defer = true;

    script.onload = () => {
      if (globalName && window[globalName]) {
        resolve(window[globalName]);
      } else if (!globalName) {
        resolve();
      } else {
        reject(new Error(`Global variable ${globalName} not found after script load.`));
      }
    };

    script.onerror = () => {
      reject(new Error(`Failed to load script: ${url}`));
    };

    document.head.appendChild(script);
  });
};

//----------- Load Script Function -----------//
bcl.u.loadScript = function (obj) {
  const existingScript = Array.from(document.querySelectorAll("script")).find((script) => script.src === obj.src.replace(".js", ""));

  if (existingScript) {
    obj.callback?.(true);
    return;
  }

  const js = document.createElement("script");
  js.src = obj.src.includes("external=true") ? obj.src : obj.src.replace(".js", `.lc-${bcl.u.getLongCacheKey()}-lc.min.js`);

  js.async = true;
  if (obj.crossOrigin) {
    js.crossOrigin = "anonymous";
  }
  if (obj.id) {
    js.id = obj.id;
  }
  if (obj.type) {
    js.type = obj.type;
  }

  js.onload = () => obj.callback?.(true);
  js.onerror = () => obj.callback?.(false, new Error(`Failed to load script ${obj.src}`));

  if (crossOriginURLS.test(window.location.hostname)) {
    js.src = js.src.replace(window.location.hostname, "www.barcelo.com");
  }

  document.head.appendChild(js);
};

//----------- Load StyleSheet Function -----------//

window.bcl.u.loadedStyles = new Set();

bcl.u.loadStyleSheet = (src, classSelector, emmitEventOnLoad) => {
  return new Promise((resolve, reject) => {
    if (crossOriginURLS.test(window.location.hostname)) {
      src = "https://www.barcelo.com" + src;
    }

    const cacheKey = bcl.u.getLongCacheKey();
    const newHref = src.replace(".css", `.lc-${cacheKey}-lc.min.css`);

    if (bcl.u.loadedStyles.has(newHref)) {
      const existingSS = Array.from(document.querySelectorAll('link[rel="stylesheet"], link[rel="preload"]')).find((link) => link.href.includes(newHref));

      if (existingSS) {
        if (existingSS.rel === "preload") {
          existingSS.rel = "stylesheet";
        }
      }

      document.querySelectorAll(classSelector).forEach((element) => {
        element.querySelectorAll(".component-loader").forEach((loader) => loader.remove());
        element.classList.replace("hiddenComponent", "visibleComponent");
      });

      if (emmitEventOnLoad) {
        document.dispatchEvent(new CustomEvent("stylesLoaded_" + classSelector));
      }

      resolve();
      return;
    }

    bcl.u.loadedStyles.add(newHref);

    const preloadLink = document.createElement("link");
    preloadLink.rel = "preload";
    preloadLink.href = newHref;
    preloadLink.as = "style";
    preloadLink.setAttribute("importance", "high");

    preloadLink.onload = () => {
      preloadLink.rel = "stylesheet";

      document.querySelectorAll(classSelector).forEach((element) => {
        element.querySelectorAll(".component-loader").forEach((loader) => loader.remove());
        element.classList.replace("hiddenComponent", "visibleComponent");
      });

      if (emmitEventOnLoad) {
        document.dispatchEvent(new CustomEvent("stylesLoaded_" + classSelector));
      }

      resolve();
    };

    preloadLink.onerror = () => {
      console.error(`Error preloading stylesheet: ${src}`);
      bcl.u.loadedStyles.delete(newHref);
      reject(new Error(`Error preloading stylesheet: ${src}`));
    };

    document.head.appendChild(preloadLink);
  });
};

//----------------------------------------------------------------//

const getFunctionByPath = function (path, obj = window) {
  return path.split(".").reduce((prev, curr) => prev && prev[curr], obj);
};

//----------------------------------------------------------------//

bcl.u.retryInit = function (componentPath, maxRetries = 5, delay = 1000) {
  let retryCount = 0;

  const tryInit = () => {
    const component = getFunctionByPath(componentPath);

    try {
      component.init();
    } catch (error) {
      retryCount += 1;
      // console.warn(`Initialization failed. Retry ${retryCount} of ${maxRetries} for ${componentPath}.`);

      if (retryCount < maxRetries) {
        setTimeout(tryInit, delay);
      } else {
        console.error("Initialization failed after multiple attempts.");
        console.error("Failed component path:", componentPath);
      }
    }
  };

  tryInit();
};

//----------------------------------------------------------------//

// Commons Utils
bcl.u.docReady = function (callback, skipEvent) {
  if (document.readyState !== "loading") {
    if (bcl.load) {
      callback();
    } else {
      bcl.preInit.push(callback);
    }
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      callback();
    });
  }

  if (!skipEvent && !bcl.editMode) {
    document.addEventListener("modal-open", function (elem) {
      callback(elem.detail);
    });
    document.addEventListener("ajax-executed", function (elem) {
      callback(elem.detail);
    });
  }
};

//----------------------------------------------------------------//

bcl.u.redirectForm = function (data, container) {
  const submitForm = container.querySelector(".submit-form-JS");
  if (submitForm && data.authenticate) {
    submitForm.elements.RelayState.value = data.Message + "&redirectOnError=1";
    const submitButton = container.querySelector(".submit-button-JS");
    if (submitButton) {
      submitButton.click();
    }
  }
};

//----------------------------------------------------------------//

bcl.u.computeScript = function (elem) {
  if (!elem) {
    return;
  }

  try {
    const scripts = Array.from(elem.getElementsByTagName("script"));

    scripts.forEach((script) => {
      const newScript = document.createElement("script");

      if (script.src) {
        newScript.src = script.src;
        document.head.appendChild(newScript);
      } else {
        newScript.text = script.innerHTML;
        document.head.appendChild(newScript);
      }
    });
  } catch (error) {
    console.error("Error executing modal scripts:", error);
  }
};

//----------------------------------------------------------------//
bcl.u.preInit = function () {
  for (let i = 0; i < bcl.preInit.length; i++) {
    bcl.preInit[i]();
  }

  bcl.preInit = [];
  bcl.u.triggerEvent(window, "preInitLoaded");
};

//----------------------------------------------------------------//

bcl.u.resize = function (callback, node = window) {
  node.addEventListener("resize", callback);
};

//----------------------------------------------------------------//

bcl.u.validateEmail = function (mail) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(mail);
};

//----------------------------------------------------------------//

bcl.u.forEach = function ($elements, callback) {
  if ($elements) {
    Array.prototype.forEach.call($elements, callback);
  }
};

//----------------------------------------------------------------//

bcl.u.getParent = function ($child, $class) {
  while ($child != null && !bcl.u.containsClass($child, $class)) {
    $child = $child.parentElement;
  }
  return $child;
};

//----------------------------------------------------------------//

bcl.u.findLowestCommonAncestor = function (nodes) {
  if (!nodes || nodes.length === 0) {
    return null;
  }
  let commonAncestor = nodes[0];
  while (commonAncestor.parentNode) {
    if (nodes.every((node) => commonAncestor.contains(node))) {
      return commonAncestor;
    }
    commonAncestor = commonAncestor.parentNode;
  }
  return null;
};

//----------------------------------------------------------------//

// bcl.u.getFileErrorElement = function ($el) {
//   const errorField = $el.parentNode.getElementsByClassName("file-size-error");

//   if (errorField.length) {
//     return errorField[0].firstElementChild;
//   }
// };

// //----------------------------------------------------------------//

// bcl.u.getFileErrorTypeElement = function ($el) {
//   const errorField = $el.parentNode.getElementsByClassName("file-type-error");

//   if (errorField.length) {
//     return errorField[0].firstElementChild;
//   }
// };

// //----------------------------------------------------------------//

bcl.u.removeClass = function ($el, className) {
  if (!$el || !className) {
    return;
  }

  if ($el instanceof Array) {
    bcl.u.forEach($el, function ($elInner) {
      bcl.u.removeClass($elInner, className);
    });
  } else {
    if ($el.classList) {
      $el.classList.remove(className);
    } else if ($el.className) {
      $el.className = $el.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
  }
};

//----------------------------------------------------------------//

bcl.u.removeClassWithRegex = function ($el, regEx) {
  if (!$el || !regEx) {
    return false;
  }

  const classList = $el.classList || ($el.className && $el.className.split(" "));
  if (!classList) {
    return false;
  }

  let classToRemove = false;
  classList.forEach((cls) => {
    if (regEx.test(cls)) {
      bcl.u.removeClass($el, cls);
      classToRemove = true;
    }
  });

  return classToRemove;
};

//----------------------------------------------------------------//

bcl.u.addClass = function ($el, className) {
  if ($el && className) {
    if ($el instanceof Array) {
      bcl.u.forEach($el, function ($elInner) {
        bcl.u.addClass($elInner, className);
      });
    } else {
      if ($el.classList) {
        className = className.replace(/  +/g, " ");
        let classes = className.split(" ");
        classes = classes.filter(Boolean);
        for (let i = 0; i < classes.length; i++) {
          $el.classList.add(classes[i]);
        }
      } else {
        $el.className += " " + className;
      }
    }
  }
};

//----------------------------------------------------------------//

bcl.u.toggleClass = function ($el, className) {
  if (!$el) {
    return;
  }

  if ($el.classList) {
    $el.classList.toggle(className);
  } else {
    const classes = $el.className.split(" "),
      existingIndex = classes.indexOf(className);

    if (existingIndex >= 0) {
      classes.splice(existingIndex, 1);
    } else {
      classes.push(className);
    }

    $el.className = classes.join(" ");
  }
};

//----------------------------------------------------------------//

bcl.u.containsClass = function ($el, className) {
  if (!$el) {
    return false;
  }

  if ($el.classList) {
    return $el.classList.contains(className);
  }

  return new RegExp("(^| )" + className + "( |$)", "gi").test($el.className);
};

//----------------------------------------------------------------//

bcl.u.removeAllClass = function ($el) {
  if ($el.classList) {
    $el.classList = [];
  } else {
    $el.className = "";
  }
};

//----------------------------------------------------------------//

bcl.u.copyAllClass = function ($el, $copy) {
  if (!$el || !$copy) {
    return;
  }

  $copy.className = $el.className;
};

//----------------------------------------------------------------//

bcl.u.listRemoveClass = function ($elements, classStr) {
  if ($elements && $elements.length > 0) {
    for (let i = 0; i < $elements.length; i++) {
      if (Array.isArray(classStr)) {
        bcl.u.forEach(classStr, function (className) {
          bcl.u.removeClass($elements[i], className);
        });
      } else {
        bcl.u.removeClass($elements[i], classStr);
      }
    }
  }
};

//----------------------------------------------------------------//

bcl.u.listAddClass = function ($elements, classStr) {
  if ($elements && $elements.length > 0) {
    for (let i = 0; i < $elements.length; i++) {
      if (Array.isArray(classStr)) {
        bcl.u.forEach(classStr, function (className) {
          bcl.u.addClass($elements[i], className);
        });
      } else {
        bcl.u.addClass($elements[i], classStr);
      }
    }
  }
};

//----------------------------------------------------------------//

bcl.u.hiddeElements = function ($elements, classStr) {
  if ($elements && $elements.length > 0) {
    for (let i = 0; i < $elements.length; i++) {
      bcl.u.addClass($elements[i], classStr || "hidden");
    }
  }
};

//----------------------------------------------------------------//

bcl.u.removeElements = function ($elements) {
  if ($elements && $elements.length > 0) {
    for (let i = 0; i < $elements.length; i++) {
      $elements[i].parentNode.removeChild($elements[i]);
    }
  }
};

//----------------------------------------------------------------//

bcl.u.showElements = function ($elements, classStr) {
  if ($elements && $elements.length > 0) {
    for (let i = 0; i < $elements.length; i++) {
      bcl.u.removeClass($elements[i], classStr || "hidden");
    }
  }
};

bcl.u.browser = {
  isSafari: function () {
    return !bcl.u.browser.isChrome() && navigator.userAgent.indexOf("Safari") !== -1;
  },
  isEdge: function () {
    return navigator.userAgent.indexOf("Edg") !== -1;
  },
  IE11: function () {
    return navigator.userAgent.indexOf("MSIE ") !== -1 || navigator.userAgent.indexOf("Trident/") !== -1;
  },
  IE: function () {
    return navigator.userAgent.indexOf("MSIE") !== -1;
  },
  isFirefox: function () {
    return navigator.userAgent.indexOf("Firefox") !== -1;
  },
  isChrome: function () {
    return navigator.userAgent.indexOf("Chrome") !== -1;
  },
};

//----------------------------------------------------------------//

bcl.u.loadAsyncData = function () {
  const domAsyncLoad = document.querySelectorAll("[data-async-load]");

  if (domAsyncLoad.length > 0) {
    bcl.u.forEach(domAsyncLoad, function ($el) {
      const callback = $el.getAttribute("data-async-callback"),
        url = $el.getAttribute("data-async-load"),
        post = $el.getAttribute("data-async-type"),
        noDelete = $el.getAttribute("data-not-delete"),
        spinner = $el.getAttribute("data-spinner"),
        noRemoveAttribute = $el.getAttribute("data-no-remove-attribute");

      if (spinner) {
        bcl.u.addSpinner($el);
      }

      if (post && post === "POST") {
        bcl.ajax.postRequest({
          url: url,
          callback: callback,
          itemCallback: $el,
        });
      } else {
        bcl.ajax.getRequest(noDelete ? null : $el, url, callback, $el);
      }

      if (!noRemoveAttribute) {
        $el.removeAttribute("data-async-load");
        $el.removeAttribute("data-async-callback");
        $el.removeAttribute("data-async-type");
        $el.removeAttribute("data-not-delete");
        $el.removeAttribute("data-spinner");
      }
    });
  }
};

//----------------------------------------------------------------//

bcl.u.params = function (paramsObject) {
  if (!paramsObject) {
    return;
  }

  const urlParams = new URLSearchParams(Object.entries(paramsObject));
  return urlParams.toString();
};

//----------------------------------------------------------------//

bcl.u.getParameterByName = function (name, url) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

bcl.u.removeUrlParameter = function (name, url) {
  if (!url) {
    url = window.location.href;
  }
  const queryString = url.split("?")[1].split("&");

  if (queryString.length > 1) {
    let queryParams = "";
    for (let i = 0; i < queryString.length; i++) {
      let key = "";
      if (queryString[i].indexOf("=") > -1) {
        key = queryString[i].split("=")[0];
        if (key !== name) {
          queryParams = queryParams.length > 0 ? queryParams + "&" + queryString[i] : queryString[i];
        }
      }
    }
    return queryParams;
  }
  return "";
};

//----------------------------------------------------------------//

bcl.u.executeFunctionByName = function (functionName, context, ...args) {
  const namespaces = functionName.split(".");
  const func = namespaces.pop();
  for (let i = 0; i < namespaces.length; i++) {
    context = context[namespaces[i]];
  }
  if (context?.[func]) {
    return context[func](...args);
  }
};

//----------------------------------------------------------------//

bcl.u.serializeObject = function (obj) {
  const pairs = [];
  for (const prop in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, prop)) {
      continue;
    }
    if (Object.prototype.toString.call(obj[prop]) == "[object Object]") {
      pairs.push(bcl.u.serializeObject(obj[prop]));
      continue;
    }
    pairs.push(prop + "=" + obj[prop]);
  }
  return pairs.join("&");
};

//----------------------------------------------------------------//

bcl.u.deepExtend = function (out = {}, ...sources) {
  for (const obj of sources) {
    if (!obj) {
      continue;
    }

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key];
        if (typeof value === "object" && value !== null) {
          out[key] = bcl.u.deepExtend(out[key] || {}, value);
        } else {
          out[key] = value;
        }
      }
    }
  }

  return out;
};

//----------------------------------------------------------------//

bcl.u.wrap = function (el, wrapper) {
  el.parentNode.insertBefore(wrapper, el);
  return wrapper.appendChild(el);
};

//----------------------------------------------------------------//

bcl.u.resetImage = function ($imgContainer) {
  if ($imgContainer) {
    const $img = $imgContainer.getElementsByTagName("img");
    if (!$img || $img.length === 0) {
      return;
    }

    const $noScript = document.createElement("noscript");
    $noScript.setAttribute("data-cmp-hook-image", "noscript");
    bcl.u.wrap($img[0], $noScript);

    $img[0].setAttribute("src", $imgContainer.getAttribute("data-asset"));
    $img[0].setAttribute("data-cmp-hook-image", "image");

    $imgContainer.setAttribute("data-cmp-is", "image");
  }
};

//----------------------------------------------------------------//

bcl.u.swiper = {
  init: function (baseDom, properties) {
    let swiper = null;
    const baseFind = baseDom ? baseDom : document;
    const elements = baseFind.getElementsByClassName(properties.cssSelector);

    //TODO: REFACTOR THIS
    bcl.u.forEach(elements, function ($element, index) {
      if ($element?.swiper) {
        return;
      }
      $element.classList.add("element-" + index);
      const asyncObj = $element.querySelector(properties.cssSelectorSwiper);
      if (asyncObj) {
        let dataInfo;
        if (properties?.nameAttr) {
          dataInfo = asyncObj.getAttribute(properties.nameAttr) + (bcl.u.mobile.isMobile() ? "?isMobile=true" : "");
        }
        if (dataInfo && dataInfo != "null") {
          bcl.ajax.getRequest(asyncObj, dataInfo, function () {
            if (!asyncObj.innerHTML.trim()) {
              const backupImg = (asyncObj.closest(".cmp-bhg-carousel") || asyncObj).querySelector(".no-carousel-backup-JS");
              if (backupImg) {
                backupImg.classList.remove("hidden");
                window.dispatchEvent(new Event("update"));
              }
            }
            swiper = bcl.u.swiper.configure($element, properties);
          });
        } else {
          swiper = bcl.u.swiper.configure($element, properties);
        }
      } else {
        swiper = bcl.u.swiper.configure($element, properties);
      }
    });
    return swiper;
  },

  changeParent: function ($element, hasMultipleColumns) {
    //Fix Overflow
    const sWrapper = $element.querySelector(".swiper-wrapper");
    const wrapper = document.createElement("div");
    bcl.u.addClass(wrapper, "swiper-wrapper-overflow");
    hasMultipleColumns && bcl.u.addClass(wrapper, "swiper-grid");
    bcl.u.wrap(sWrapper, wrapper);

    return sWrapper;
  },

  configure: function ($element, props) {
    const sWrapper = $element.querySelector(".swiper-wrapper");
    let hasMultipleColumns = false;

    if (!sWrapper || sWrapper.children.length < 2) {
      bcl.u.removeClass($element, "cmp-bhg-swiper-js");

      bcl.u.swiper.changeParent($element);
      const $buttons = $element.querySelectorAll(".swiper-button-JS");

      bcl.u.forEach($buttons, function ($button) {
        $button.parentNode.removeChild($button);
      });

      return;
    }

    const properties = bcl.u.deepExtend({}, props.config);

    if (properties.navigation) {
      const elementClassName = "." + $element.className.replaceAll(" ", ".");
      properties.navigation.prevEl = elementClassName + " .swiper-button-prev";
      properties.navigation.nextEl = elementClassName + " .swiper-button-next";
    }

    let slides = null;

    if ($element.dataset.numberslidesmobile && bcl.u.mobile.isMobile()) {
      slides = $element.dataset.numberslidesmobile;
    }

    if (slides || $element.dataset.numberslides) {
      properties.slidesPerView = slides || $element.dataset.numberslides ? slides || $element.dataset.numberslides : "auto";

      properties.spaceBetween = $element.dataset.spacebetween ? parseInt($element.dataset.spacebetween) : 15;

      if (properties.pagination) {
        delete properties.pagination.type;
        properties.pagination.clickable = true;
      }

      if ($element.dataset.numberslides) {
        properties.breakpoints = {};

        properties.breakpoints[bcl.u.breakMobile] = {
          slidesPerView: $element.dataset.numberslides,
          spaceBetween: $element.dataset.spacebetween ? parseInt($element.dataset.spacebetween) : 0,
        };
      }
    }

    if ($element.dataset.slideperviewauto === "true") {
      properties.slidesPerView = "auto";
    }

    if ($element.dataset.centerslides === "true") {
      properties.centeredSlides = true;
    }

    if (!properties.loop && $element.dataset.loop === "true") {
      properties.loop = true;
    }

    if ($element.dataset.autoplay === "true") {
      properties.loop = true;
      properties.autoplay = {
        delay: parseInt($element.dataset.delay),
        disableOnInteraction: $element.dataset.disableoninteraction === "true",
      };
    }

    if ($element.dataset.index) {
      properties.initialSlide = $element.dataset.index;
    }

    if (parseInt($element.dataset.slidespercolumn) > 1) {
      properties.grid = {
        rows: parseInt($element.dataset.slidespercolumn),
        fill: "row",
      };

      properties.centeredSlides = false;
      hasMultipleColumns = true;
    }

    if ($element.dataset.pointpagination === "true" || $element.closest(".pag-bullets-true-JS")) {
      delete properties.pagination.type;
      properties.pagination.renderBullet = function (index, className) {
        return `<span class="${className} ${className}-${index}"></span>`;
      };
    }

    if ($element.id.includes("detail_carousel") || ($element.dataset.disablepagination && $element.dataset.disablepagination === "true")) {
      properties.pagination = false;
    } else {
      if ($element.dataset.clickable === "true") {
        properties.pagination.clickable = true;
      }

      if ($element.dataset.mousewheel === "true") {
        properties.mousewheel = {
          releaseOnEdges: true,
        };
      }
    }

    if (bcl.editMode) {
      properties.loop = false;
    }

    properties.init = false;

    const mySwiper = new window.Swiper($element, properties);

    const addKeyboardSupport = (button) => {
      if (!button || button.dataset.keyboardSupportAttached === "true") {
        return;
      }
      button.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          this.click();
        }
      });
      button.dataset.keyboardSupportAttached = "true";
    };

    /**
     * Actualiza los atributos ARIA del carrusel (slides, botones, y el anunciador)
     * basándose en el estado actual.
     */
    const updateNavigationAria = () => {
      if (!mySwiper?.slides?.length || mySwiper?.slides?.length === 0) {
        return;
      }

      const { slides, navigation, activeIndex, el, pagination } = mySwiper;

      slides.forEach((slide, index) => {
        if (activeIndex === index) {
          slide.removeAttribute("aria-hidden");
        } else {
          slide.setAttribute("aria-hidden", "true");
        }
      });

      if (pagination != null && pagination != undefined && pagination?.bullets && pagination?.bullets?.length > 0) {
        const bullets = pagination.bullets;
        bullets.forEach((bullet, index) => {
          index === activeIndex ? bullet.setAttribute("aria-current", "true") : bullet.removeAttribute("aria-current");
        });
      }
      if (mySwiper?.el?.closest(".tingle-modal-box")) {
        const i18n = {
          "es-ES": `Mostrando ${activeIndex + 1} de ${slides.length}`,
          "en-US": `Showing ${activeIndex + 1} of ${slides.length}`,
        };
        const lang = document.documentElement.lang || "en-US";
        const message = i18n[lang] || i18n["en-US"];
        bcl.ariaUtils.announce(message);
      }
      const toggleAriaDisabled = (el, isDisabled) => {
        if (isDisabled) {
          el.setAttribute("aria-disabled", "true");
        } else {
          el.removeAttribute("aria-disabled");
        }
      };
      if (navigation?.prevEl && navigation?.nextEl) {
        const isFirst = activeIndex === 0;
        const isLast = activeIndex === slides.length - 1;
        toggleAriaDisabled(navigation.prevEl, isFirst);
        toggleAriaDisabled(navigation.nextEl, isLast);
      }
    };

    const initAccesibilityBullets = () => {
      const bullets = mySwiper?.pagination?.bullets;
      if (bullets != null && bullets != undefined && bullets.length > 0) {
        const activeIndex = mySwiper.activeIndex;
        bullets.forEach((bullet, index) => {
          bullet.setAttribute("role", "button");
          bullet.setAttribute("tabindex", "0");
          bullet.setAttribute("aria-label", `Slide ${index + 1}`);
          index === activeIndex ? bullet.setAttribute("aria-current", "true") : bullet.removeAttribute("aria-current");
          addKeyboardSupport(bullet);
        });
      }
    };
    mySwiper.on("init", function () {
      const $items = $element.querySelectorAll(".swiper-slide-duplicate .cmp-image .cmp-image__image--is-loading");
      if ($items.length) {
        bcl.u.forEach($items, function ($item) {
          bcl.u.resetImage($item.parentNode);
        });
      }
      if (mySwiper.navigation?.prevEl && mySwiper.navigation?.nextEl) {
        initAccesibilityBullets();
        updateNavigationAria();
        addKeyboardSupport(mySwiper.navigation.prevEl);
        addKeyboardSupport(mySwiper.navigation.nextEl);
      }
    });

    mySwiper.init();
    mySwiper.on("slideChange", function () {
      updateNavigationAria();
    });
    mySwiper.on("sliderMove", function () {
      if (!bcl.u.mobile.isMobile()) {
        if (mySwiper.slides) {
          const currentSlide = mySwiper.slides[mySwiper.activeIndex];

          if (bcl.u.closest(currentSlide, ".swiper")) {
            bcl.c?.assetVideo?.stopAllVideosWithSound(currentSlide);
          }
        }
      }
    });

    bcl.u.swiper.changeParent($element, hasMultipleColumns);

    if ($element && bcl.editMode) {
      if (window.Granite && window.window.Granite.author && window.window.Granite.author.MessageChannel) {
        /*
         * Editor message handling:
         * - subscribe to "cmp.panelcontainer" message requests sent by the editor frame
         * - check that the message data panel container type is correct and that the id (path) matches this specific Carousel component
         * - if so, route the "navigate" operation toe enact a navigation of the Carousel based on index data
         */
        new window.window.Granite.author.MessageChannel("cqauthor", window).subscribeRequestMessage("cmp.panelcontainer", function (message) {
          const elemDatasetCmpPanelcontainerId = $element.dataset.cmpPanelcontainerId;

          if (message.data && message.data.type === props.cssSelector && message.data.id === elemDatasetCmpPanelcontainerId) {
            if (message.data.operation === "navigate") {
              mySwiper.slideTo(message.data.index, 1000, true);
            }
          }
        });
      }
    }
    return mySwiper;
  },
};

//----------------------------------------------------------------//

bcl.u.updateClassByDotsScore = function ($subNode, value, i) {
  const classNameFull = "ta__dot--full",
    classNameHalf = "ta__dot--half",
    classNameEmpty = "empty";

  if (value >= i + 1) {
    bcl.u.addClass($subNode, classNameFull);
  } else if (value >= i + 0.5) {
    bcl.u.addClass($subNode, classNameHalf);
  } else {
    bcl.u.addClass($subNode, classNameEmpty);
  }
};

//----------------------------------------------------------------//

bcl.u.getInData = function (obj, path) {
  if (!obj || !path) {
    return null;
  }

  // Cache the current object
  let current = obj;
  path = path.split(".");
  // For each item in the path, dig into the object
  for (let i = 0; i < path.length; i++) {
    // If the item isn't found, return the default (or null)
    if (!current[path[i]] && isNaN(current[path[i]])) {
      return null;
    }

    // Otherwise, update the current  value
    current = current[path[i]];
  }

  return current;
};

//----------------------------------------------------------------//

bcl.u.getOffset = function (el) {
  const rect = el.getBoundingClientRect();

  return {
    left: rect.left + (window.scrollX || document.documentElement.scrollLeft),
    top: rect.top + (window.scrollY || document.documentElement.scrollTop),
    right: rect.left + (window.scrollX || document.documentElement.scrollLeft) + el.offsetWidth,
    bottom: rect.top + (window.scrollY || document.documentElement.scrollTop) + el.offsetHeight,
  };
};

//----------------------------------------------------------------//

bcl.u.getSelectedOption = function ($el) {
  let opt;
  for (let i = 0; i < $el.options.length; i++) {
    opt = $el.options[i];
    if (opt.selected === true) {
      break;
    }
  }
  return opt;
};

//----------------------------------------------------------------//

bcl.u.wrap = function (el, wrapper) {
  if (el && wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  }
};

//----------------------------------------------------------------//

bcl.u.triggerEvent = function (el, type) {
  let e;
  if ("createEvent" in document) {
    // modern browsers, IE9+
    e = document.createEvent("HTMLEvents");
    e.initEvent(type, false, true);
    el.dispatchEvent(e);
  } else {
    // IE 8
    e = document.createEventObject();
    e.eventType = type;
    el.fireEvent("on" + e.eventType, e);
  }
};

//----------------------------------------------------------------//

bcl.u.goToWithScroll = function (obj) {
  const $node = (obj && obj.node) || window,
    top = obj && !isNaN(obj.top) ? obj.top : 0,
    left = obj && !isNaN(obj.left) ? obj.left : 0;

  if (bcl.u.mobile.iOS() || bcl.u.browser.IE() || bcl.u.browser.IE11()) {
    if (obj && obj.node) {
      $node.scrollTo(left, top);
    } else {
      bcl.u.scrollToSmoothly(top, 1000);
    }
  } else {
    $node.scroll({
      top: top,
      left: left,
      behavior: (obj && obj.behavior) || "smooth",
    });
  }
};

//----------------------------------------------------------------//

bcl.u.scrollToSmoothly = function (pos, time) {
  /*Time is exact amount of time the scrolling will take (in milliseconds)*/
  /*Pos is the y-position to scroll to (in pixels)*/
  /*Code written by hev1*/
  if (typeof pos !== "number") {
    pos = parseFloat(pos);
  }
  if (isNaN(pos)) {
    console.warn("Position must be a number or a numeric String.");
    throw new Error("Position must be a number");
  }
  if (pos < 0 || time < 0) {
    return;
  }
  const currentPos = window.scrollY || document.documentElement.scrollTop || window.screenTop;
  let start = null;
  time = time || 500;
  window.requestAnimationFrame(function step(currentTime) {
    start = !start ? currentTime : start;
    let progress;
    if (currentPos < pos) {
      progress = currentTime - start;
      window.scrollTo(0, ((pos - currentPos) * progress) / time + currentPos);
      if (progress < time) {
        window.requestAnimationFrame(step);
      } else {
        window.scrollTo(0, pos);
      }
    } else {
      progress = currentTime - start;
      window.scrollTo(0, currentPos - ((currentPos - pos) * progress) / time);
      if (progress < time) {
        window.requestAnimationFrame(step);
      } else {
        window.scrollTo(0, pos);
      }
    }
  });
};

//----------------------------------------------------------------//

bcl.u.decodeHTML = function (html) {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

//----------------------------------------------------------------//

bcl.u.getCurrency = function (code) {
  const obj = {
    AED: "د.إ",
    AWG: "ƒ",
    BRL: "R$",
    BGN: "лв",
    CAD: "C$",
    CHF: "CHF",
    CLP: "$",
    COP: "$",
    CRC: "₡",
    CUP: "₱",
    CZK: "Kč",
    DKK: "kr",
    DOP: "RD$",
    EGP: "£",
    EUR: "€",
    GBP: "£",
    GTQ: "Q",
    HUF: "Ft",
    LKR: "Rs",
    MAD: "MAD",
    MXN: "MXN$",
    NIO: "C$",
    NOK: "kr",
    PEN: "S/.",
    PLN: "zł",
    RUB: "₽",
    SEK: "kr",
    TRY: "₺‎",
    UYU: "$U",
    USD: "$",
    VES: "Bs",
    SAR: "SAR",
    OMR: "﷼",
    KWD: " د.ك",
    QAR: "QR",
    ILS: "₪",
    BHD: "BD",
    RON: "RON",
    ARS: "ARS$",
    IDR: "Rp",
    AUD: "$",
    INR: "₹",
    CNY: "¥",
    THB: "฿",
    CVE: "Esc$",
  };

  if (!code) {
    code = bcl.s.currency.props.currency.current;
  }

  return code ? obj[code] || "" : "";
};

//----------------------------------------------------------------//

bcl.u.removeAccents = function (value) {
  return value ? value.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : "";
};

//----------------------------------------------------------------//

bcl.u.putInBold = function (string, item) {
  if (!item || !string) {
    return {
      value: string,
      matched: false,
    };
  }

  // the completed string will be itself if already set, otherwise, the string that was passed in
  const cItem = item.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
    cString = string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  const reg = "(" + cItem + ")(?![^<]*>|[^<>]*</)", // explanation: http://stackoverflow.com/a/18622606/1147859
    regex = new RegExp(reg, "i"),
    match = cString.match(regex);

  // If the regex doesn't match the string just exit
  if (!match) {
    return {
      value: string,
      matched: false,
    };
  }

  // Otherwise, get to highlighting,
  const matchStartPosition = match.index,
    matchEndPosition = matchStartPosition + cString.match(regex)[0].toString().length,
    originalTextFoundByRegex = string.substring(matchStartPosition, matchEndPosition),
    firstPart = bcl.u.putInBold(string.substring(0, matchStartPosition), item),
    secondPart = bcl.u.putInBold(string.substring(matchEndPosition, string.length), item),
    value = firstPart.value + "<strong>" + originalTextFoundByRegex + "</strong>" + secondPart.value;

  return {
    value: value,
    matched: !!match.length || firstPart.value || secondPart.value,
  };
};

//----------------------------------------------------------------//

bcl.u.serializeForm = function (form, array, encode) {
  // Setup our serialized data
  let serialized = {};
  serialized.keys = [];

  if (array) {
    serialized = [];
    serialized["keys"] = [];
  }

  // Loop through each field in the form
  for (let i = 0; i < form.elements.length; i++) {
    const field = form.elements[i];
    let name = "",
      value = "";

    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if ((!field.name && !field.id) || field.disabled || field.type === "file" || field.type === "reset" || field.type === "submit" || field.type === "button") {
      continue;
    }

    // If a multi-select, get all selections
    if (field.type === "select-multiple") {
      for (let n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) {
          continue;
        }
        name = field.name || field.id;
        value = field.options[n].value;
      }
    } else if (bcl.u.isPhoneField(field)) {
      name = field.name || field.id;
      value = bcl.s.intlTelInput.getPhone(field);
    }
    // Convert field data to a query string
    else if ((field.type !== "checkbox" && field.type !== "radio" && field.value) || field.checked) {
      name = field.name || field.id;
      value = field.value;
    }

    if ((field.required && !field.validity.valid) || bcl.u.containsClass(form, bcl.s.form.props.classErrorValidationForm)) {
      return false;
    }

    bcl.u.pushField(array, serialized, encode, name, value);

    if (bcl.u.isPhoneField(field)) {
      const dialName = name + "-dial";
      const dialValue = window.intlTelInputGlobals.getInstance(field).selectedCountryData.dialCode;
      bcl.u.pushField(array, serialized, encode, dialName, dialValue);
    }
  }

  if (array) {
    return serialized.join("&");
  }

  return serialized;
};

//----------------------------------------------------------------//

bcl.u.pushField = function (array, serialized, encode, name, value) {
  if (!array) {
    if (serialized[name]) {
      const valueItem = serialized[name];
      if (!Array.isArray(serialized[name])) {
        serialized[name] = [valueItem];
      }
      serialized[name].push(value);
    } else {
      serialized[name] = value;
    }
    if (serialized["keys"].indexOf(name) < 0) {
      serialized["keys"].push(name);
    }
  } else if (encode) {
    serialized.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
  } else {
    serialized.push(name + "=" + value);
  }
};

//----------------------------------------------------------------//

bcl.u.isPhoneField = function (field) {
  return field.type === "tel" && bcl.u.containsClass(field, bcl.s.intlTelInput.props.cssSelector);
};

//----------------------------------------------------------------//

bcl.u.addSpinner = function ($container) {
  bcl.u.addClass($container, "loading-dots");
};

//----------------------------------------------------------------//

bcl.u.addBhgLoading = function ($container, defaultLoader, isFullScreen) {
  const $content = document.createElement("div");
  const loaderHtml =
    bcl.s.loading.props.loader && !defaultLoader
      ? bcl.s.loading.props.loader.outerHTML
      : // eslint-disable-next-line @stylistic/js/max-len
        '<div class="bhg-loading dynamicLoading hiddenComponent mod--loading-active common-transition"><div class="bhg-loading__logo"> <?xml version="1.0" encoding="utf-8"?> <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 362.2 378.4" style="enable-background:new 0 0 362.2 378.4;" xml:space="preserve"><style type="text/css">.st0{fill:#384044}.st1{fill:none;stroke:#384044;stroke-miterlimit:10}.st2{fill:none;stroke:#384044;stroke-width:1.2853;stroke-miterlimit:10}.st3{fill:none;stroke:#384044;stroke-width:1.285;stroke-miterlimit:10}</style><g id="b-fill"> <path class="st0" d="M228.1,178.7c17.2-10.5,25.6-25.6,25.6-46.1c0-39.1-23.5-58.1-71.7-58.1H80c-1.4,0-2.5,1.2-2.5,2.6v223.6 c0,1.5,1.1,2.6,2.5,2.6h105c36.4,0,79-17.7,79-67.5C264,207.9,251.3,187.8,228.1,178.7z M130.1,118h42.1c20.6,0,30.2,7.3,30.2,23.1 c0,19.8-14.5,24-26.6,24h-45.7V118L130.1,118z M178.6,260h-48.4v-56.1h49.3c21.4,0,31.7,9.6,31.7,29.3 C211.2,251.2,200.5,260,178.6,260z"/> </g> <g id="b-hole-1"> <path class="st1" d="M130.1,165.1"/> <path class="st1" d="M175.8,165.1h-45.7V118l46.1,0.1c0,0,26.2-2.2,26.2,23S175.8,165.1,175.8,165.1z"/> </g> <g id="b-hole-2"> <path class="st1" d="M181.3,260h-51.1v-56.1l51.1-0.1c0,0,29.7-1.9,29.7,28.1S181.3,260,181.3,260z"/> </g> <g id="b-stroke"> <path class="st1" d="M77.5,141.6"/> <path class="st1" d="M77.5,165.2V76.9c0,0-0.1-0.7,0.7-1.5s1.5-0.8,1.5-0.8h101.6c0,0,70.1-4.4,72.2,52.1 c2.6,39.1-25.4,52.1-25.4,52.1s35.8,13.7,35.8,53.3c0,76.8-82.6,71.3-82.6,71.3H79.8c0,0-0.8,0-1.5-0.7s-0.7-1.6-0.7-1.6v-41 L77.5,165.2z"/> </g> <g id="circle"> <path class="st2" d="M67.5,188.2v-0.5C68,124.7,119.6,74,182.6,74.5l0,0c62.9,0.5,113.5,51.8,113.2,114.6v0.5 c-0.3,63.2-51.9,114.2-115.1,113.7l0,0C117.7,302.7,67,251.2,67.5,188.2z"/> </g> <g id="line-top"> <line class="st2" x1="37.5" y1="74.4" x2="293.9" y2="74.5"/> </g> <g id="line-bottom"> <line class="st2" x1="293.9" y1="303.4" x2="37.5" y2="303.4"/> </g> <g id="line-section-right"> <line class="st3" x1="276.2" y1="14.6" x2="232.5" y2="86.4"/> </g> <g id="line-section-left"> <line class="st2" x1="77.5" y1="178.7" x2="67.4" y2="88.1"/> </g> </svg></div></div>';

  $container?.classList.add("mod--bhg-loading");
  if ($container && !isFullScreen) {
    if (window.innerHeight < $container.offsetHeight) {
      $container.style.height = `${window.innerHeight - 100}px`;
    }
    $content.innerHTML = loaderHtml;
  } else {
    $container = document.body;
    if (bcl.s.loading.props.loader) {
      bcl.u.addClass(bcl.s.loading.props.loader, "mod--fullscreen");
    }
    $content.innerHTML = loaderHtml.replace("mod--loading-active", "mod--fullscreen mod--loading-active");
  }
  $container.appendChild($content);
};

//----------------------------------------------------------------//

bcl.u.isInViewport = function ($elem) {
  if (!$elem) {
    return false;
  }
  const bounding = $elem.getBoundingClientRect();
  return bounding.top - window.innerHeight <= 0 || bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight);
};

//----------------------------------------------------------------//

bcl.u.debounce = (func, wait, immediate = false) => {
  let timeout;

  return (...args) => {
    const callNow = immediate && !timeout;

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) {
        func(...args);
      }
    }, wait);

    if (callNow) {
      func(...args);
    }
  };
};

//----------------------------------------------------------------//

bcl.u.removeBhgLoading = function ($container) {
  if (!$container) {
    $container = document.body;
  }

  $container.removeAttribute("style");
  bcl.u.removeClass($container, "bhg-loading-wrap");
  bcl.u.removeClass($container.querySelector(".bhg-loading:not(.JS-translation-loader)"), "mod--loading-active");
  $container.classList.remove("mod--bhg-loading");
  setTimeout(function () {
    const loaders = $container.querySelectorAll(".bhg-loading:not(.JS-translation-loader)");
    const parentsDiv = [];
    if (loaders && loaders.length > 0) {
      Array.from(loaders).forEach((load) => {
        if (load.parentElement.nodeName === "DIV" && load.parentElement.classList.length === 0) {
          parentsDiv.push(load.parentElement);
        }
      });
    }
    bcl.u.removeElements(parentsDiv ? parentsDiv : loaders);
  }, 300);
};

//----------------------------------------------------------------//

bcl.u.removeSpinner = function ($container) {
  bcl.u.removeClass($container, "loading-dots");
};

//----------------------------------------------------------------//

bcl.u.textareaCountWords = function ($textarea, maximuncharacters, message) {
  let totalCharacters;
  if (message === undefined) {
    if ($textarea.value.length < maximuncharacters) {
      totalCharacters = maximuncharacters - $textarea.value.length;
    } else {
      totalCharacters = maximuncharacters;
    }
  }
  return totalCharacters;
};

//----------------------------------------------------------------//

bcl.u.setDateInUtagData = function (utagobj, startDate, endDate) {
  const sDateY = parseInt(startDate.substring(0, 4));
  const sDateM = parseInt(startDate.substring(5, 7)) - 1;
  const sDateD = parseInt(startDate.substring(8, 10));
  const eDateY = parseInt(endDate.substring(0, 4));
  const eDateM = parseInt(endDate.substring(5, 7)) - 1;
  const eDateD = parseInt(endDate.substring(8, 10));

  const today = new Date();
  const sDate = new Date(sDateY, sDateM, sDateD);
  const eDate = new Date(eDateY, eDateM, eDateD);

  utagobj.search_advance_days = "" + (Math.trunc((sDate.getTime() - today.getTime()) / (1000 * 3600 * 24)) + 1);
  utagobj.search_nights = Math.trunc((eDate.getTime() - sDate.getTime()) / (1000 * 3600 * 24)) + "";
  utagobj.search_check_in_hyphen = startDate;
  utagobj.search_check_in_yyyymmdd = startDate.replace(/-/g, "/");
  utagobj.search_check_in_date = startDate.replace(/-/g, "");
  utagobj.search_check_in_mmddyyyy = sDateM + 1 + "/" + sDateD + "/" + sDateY;
  utagobj.search_check_out_hyphen = endDate;
  utagobj.search_check_out_yyyymmdd = endDate.replace(/-/g, "/");
  utagobj.search_check_out_date = endDate.replace(/-/g, "");
  utagobj.search_check_out_mmddyyyy = eDateM + 1 + "/" + eDateD + "/" + eDateY;
  bcl.u.utag.add(utagobj);
};

//----------------------------------------------------------------//

bcl.u.activeBooking = function ($element) {
  bcl.u.addClass($element.parentNode, "hidden");

  const $card = $element.closest("." + bcl.c.distributor.results.props.classNameCard);

  if (!$card) {
    return;
  }

  let $node = $card.getElementsByClassName("mod--cta-disabled");

  if ($node && $node[0]) {
    $node = $node[0];

    bcl.u.removeClass($node, "mod--cta-disabled");

    if (bcl.u.containsClass($node, "promo-button-JS")) {
      bcl.u.addClass($node, "mod--cta-color-red");
      bcl.u.removeClass($node, "mod--cta-outline");
    }
  }
};

//----------------------------------------------------------------//

bcl.u.getCountryCode = function () {
  let code = document.body.dataset.countrycode || "es";

  if (typeof bcl.contextHub !== "undefined") {
    let profile = bcl.contextHub.get("profile");

    if (profile) {
      profile = bcl.contextHub.getItem(profile, "country_code");

      if (profile) {
        code = profile;
      }
    }
  }

  if (crossOriginURLS.test(window.location.hostname) && window.utag_data?.user_country_name) {
    code = window.utag_data.user_country_name;
  }

  return code.toLowerCase();
};

//----------------------------------------------------------------//

bcl.u.getPageLanguage = function () {
  return document.documentElement.getAttribute("lang").toLowerCase();
};

//----------------------------------------------------------------//
bcl.u.getbase64DecodedUrl = function (str) {
  try {
    if (typeof str !== "string") {
      return str;
    }

    str = str.trim();
    const base64Regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
    if (!base64Regex.test(str)) {
      return str;
    }

    const decoded = atob(str);
    if (!decoded) {
      return str;
    }
    return decoded;
  } catch (e) {
    return str;
  }
};

bcl.u.callWhenLoadUser = function (callWhenReady) {
  // Start Check login errors
  if (bcl.contextHub.props.loginError && bcl.contextHub.props.loginError.includes(bcl.cookie.get(bcl.contextHub.props.lasukmybErrorCookie))) {
    //Show modal
    const loginErrorModal = document.querySelector(".modal-login-error-JS");
    if (loginErrorModal && loginErrorModal.dataset.logout) {
      const logoutUrl = bcl.u.getbase64DecodedUrl(loginErrorModal.dataset.logout);
      bcl.u.addClass(loginErrorModal, "tingle-modal--visible");
      setTimeout(function () {
        window.location.href = logoutUrl;
      }, 3000);
    }
  }
  // End check login error

  const user = bcl.u.getContextHubUser();
  if (!user) {
    sessionStorage.removeItem(bcl.contextHub.props.nameSessionStorage + bcl.contextHub.props.nameProfile);
    bcl.contextHub.props.stores[bcl.contextHub.props.nameProfile] = null;
    bcl.contextHub.init();
    bcl.contextHub.callWhenReady(callWhenReady, bcl.contextHub.props.nameProfile);
  } else {
    if (callWhenReady && typeof callWhenReady === "function") {
      callWhenReady();
    }
  }
};

//----------------------------------------------------------------//

bcl.u.initMybUserComponents = function () {
  // Only getContextHubUser because the bcl.u.callWhenLoadUser should be called already
  const user = bcl.u.getContextHubUser();

  if (user) {
    bcl.c.header?.showModalMyBarcelo(user);
    bcl.c.mybProfile?.init(user);
  }

  bcl.c.mybLoyaltyTargeting?.init(user);
};

//----------------------------------------------------------------//

bcl.u.getContextHubUser = function () {
  let user = null;
  if (typeof bcl.contextHub !== "undefined") {
    const profile = bcl.contextHub.get("profile");
    if (profile && profile.user && ((profile.user.federationId && bcl.cookie.get(bcl.contextHub.props.lasukmybCookie) === "1") || (!profile.user.federationId && bcl.cookie.get(bcl.contextHub.props.lasukmybCookie) !== "1"))) {
      user = profile.user;
    } else if (bcl.cookie.get(bcl.contextHub.props.lasukmybCookie) === "1") {
      return null;
    }
  }
  return user;
};

//----------------------------------------------------------------//

bcl.u.setButtonOfferCard = function ($article, data) {
  const $buttons = $article.getElementsByClassName("button-JS");

  bcl.u.forEach($buttons, function ($button) {
    $button.addEventListener("click", function (e) {
      e.stopPropagation();

      if (bcl.u.containsClass($button, "mod--cta-disabled")) {
        return;
      }

      bcl.c.fastbooking.showFB();

      // Utag push
      if (bcl.u.utag.isEnabled()) {
        try {
          const campaignID = $article.getAttribute("data-offer-id-campaign")?.split("/").pop() || data.offer.name;
          const objPush = {
            ecommerce_action: "promo_click",
            ecommerce_action_field_list_gtag: window.utag_data.ecommerce_action_field_list_gtag,
            ecommerce_action_gtag: "select_promo_content",
            promo_id: [$article.getAttribute("data-offer-id")],
            promo_creative: [window.utag_data.ecommerce_action_field_list_gtag],
            promo_value: [$article.getAttribute("data-offer-value")],
            promo_name: [campaignID],
            promo_value_type: [$article.getAttribute("data-offer-type")],
            promo_position: [String(parseInt($article.dataset.index || 0) + 1)],
          };

          bcl.u.utag.push(objPush);
        } catch (e) {
          console.warn("Data push error", e);
        }
      }

      let selector,
        redirect = false;

      if (bcl.u.containsClass($button, "coupon-button-JS")) {
        bcl.c.fastbooking.discount.addPromocode($button.dataset.value, false);
      } else if (bcl.u.containsClass($button, "coupon-campaign-group-button-JS")) {
        bcl.c.fastbooking.discount.add($button.dataset.value, bcl.c.fastbooking.discount.props.attrCampaignPromo, $button.dataset.value, $button.dataset.selectorcode);
        selector = bcl.c.fastbooking.calendar.props.calendarCampaignGroupSelector;
        redirect = true;
      } else {
        selector = "calendarpromo";
        redirect = true;
      }

      const obj = {
        destination: {
          selector: selector,
          code: data.offer.id_category,
          id: data.info.hotelId,
          data: {
            adultsOnly: data.info.is_hotel_adults_only,
            minAdultsAge: data.info.minimum_age_for_adults,
            specialDiscounts: data.info.specialDiscounts,
          },
          label: data.info.search_title || data.info.name,
          type: "hotel",
        },
        offer: data.offer,
        redirect: redirect,
      };

      bcl.c.fastbooking.calendar.props.showOnlyCampaignPrices = data.offer.campaignProperties.blockedDates === "true" || data.offer.campaignProperties.blockedDates === true;

      const $buttonPromoCode = document.body.getElementsByClassName("coupon-cta-JS");

      if ($buttonPromoCode.length > 0 && !bcl.u.containsClass($buttonPromoCode, "hidden")) {
        $buttonPromoCode[0].click();
      }

      bcl.c.fastbooking.processBooking(obj);
      if (bcl.c.fastbooking.isCampaignGroup()) {
        const campaignDateStart = bcl.u.getNormalizedDate(obj.offer.travel_start);
        bcl.c.fastbooking.calendar.goToDate(campaignDateStart);
      }
    });
  });
  return true;
};

//----------------------------------------------------------------//

bcl.u.getNormalizedDate = function (date) {
  let output = new Date();

  if (date) {
    if (typeof date === "string") {
      if (date.indexOf("T") < 0 && date.indexOf(" ") < 0) {
        output = new Date(date + "T12:00:00.000Z");
      } else {
        output = new Date(date);
      }
    } else if (typeof date === "number") {
      output = new Date(date);
    } else if (typeof date === "object") {
      output = date;
    }
  }

  output.setHours(12, 0, 0);
  output.setMilliseconds(0);
  return output;
};

//----------------------------------------------------------------//

bcl.u.setStyleInElement = function ($element, property, value) {
  $element.style[property] = value;
};

//----------------------------------------------------------------//

bcl.u.goToNewTab = function (data) {
  if (bcl.u.browser.isSafari() || bcl.u.browser.IE() || bcl.u.browser.isEdge() || bcl.u.mobile.webView() || bcl.u.browser.isFirefox()) {
    window.open(data.Message, "_self");
  } else {
    window.open(data.Message, "_blank");
  }
};

//----------------------------------------------------------------//

bcl.u.getDates = function (data) {
  if (data.startDate && data.endDate) {
    return {
      arrive: data.startDate.split("T")[0],
      depart: data.endDate.split("T")[0],
    };
  } else {
    return {};
  }
};

//----------------------------------------------------------------//

bcl.u.formatDate = function (date) {
  if (!date) {
    return "";
  }

  const d = new Date(date),
    year = d.getFullYear();

  let month = "" + (d.getMonth() + 1),
    day = "" + d.getDate();

  if (month.length < 2) {
    month = "0" + month;
  }
  if (day.length < 2) {
    day = "0" + day;
  }

  return [year, month, day].join("-");
};

//----------------------------------------------------------------//

bcl.u.showDatesMessage = function (data, $el, selector) {
  const arrive = new Date(data.arrive);
  const depart = new Date(data.depart);
  const monthFrom = $el.dataset.months.split(",")[arrive.getMonth()];
  const monthTo = $el.dataset.months.split(",")[depart.getMonth()];

  bcl.u.writeDates($el, arrive.getDate(), "." + selector + "-from-JS");

  if (arrive.getMonth() !== depart.getMonth()) {
    bcl.u.writeDates($el, arrive.getMonth(), "." + selector + "month-from-JS", true, monthFrom);
  }

  if (arrive.getFullYear() !== depart.getFullYear()) {
    bcl.u.writeDates($el, arrive.getFullYear(), "." + selector + "-year-from-JS");
  }

  bcl.u.writeDates($el, depart.getDate(), "." + selector + "-to-JS");
  bcl.u.writeDates($el, depart.getMonth(), "." + selector + "-month-to-JS", true, monthTo);
  bcl.u.writeDates($el, depart.getFullYear(), "." + selector + "-year-to-JS");
};

//----------------------------------------------------------------//

bcl.u.writeDates = function ($el, value, selector, isMonth, month) {
  if ($el.querySelector(".dates-JS")) {
    const $node = $el.querySelector(".dates-JS").querySelector(selector);
    bcl.u.removeClass($el.querySelector(".dates-JS"), "hidden");
    if ($node) {
      if (isMonth) {
        $node.textContent = " " + month + " ";
      } else {
        $node.textContent = " " + value + " ";
      }
      bcl.u.removeClass($node, "hidden");
    }
  }
};

//----------------------------------------------------------------//

bcl.u.htmlToDOMElement = function (content) {
  const div = document.createElement("div");
  div.innerHTML = content.trim();
  return div.firstChild;
};

//----------------------------------------------------------------//

bcl.u.includes = function (container, value) {
  let returnValue = false;
  const pos = container.indexOf(value);
  if (pos >= 0) {
    returnValue = true;
  }
  return returnValue;
};

//----------------------------------------------------------------//

bcl.u.closest = function (el, selector) {
  let matchesFn;

  // find vendor prefix
  ["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"].some(function (fn) {
    if (typeof document.body[fn] == "function") {
      matchesFn = fn;
      return true;
    }
    return false;
  });

  let parent;

  // traverse parents
  while (el) {
    parent = el.parentElement;
    if (parent && parent[matchesFn](selector)) {
      return parent;
    }
    el = parent;
  }

  return null;
};

//----------------------------------------------------------------//

bcl.u.getUrlParam = function ($url, $param) {
  const url = new URL(window.location.host + $url);
  return url.searchParams.get($param);
};

//----------------------------------------------------------------//

bcl.u.getAllUrlParamsFromUrl = function (url) {
  let queryString = url ? url.split("?")[1] : window.location.search.slice(1);
  const obj = {};

  if (!queryString) {
    return obj;
  }

  queryString = queryString.split("#")[0];
  const arr = queryString.split("&");

  for (let i = 0; i < arr.length; i++) {
    const a = arr[i].split("=");
    let paramName = a[0];
    let paramValue = typeof a[1] === "undefined" ? true : a[1];
    paramName = paramName.toLowerCase();
    if (typeof paramValue === "string") {
      paramValue = paramValue.toLowerCase();
    }
    if (paramName.match(/\[(\d+)?\]$/)) {
      const key = paramName.replace(/\[(\d+)?\]/, "");
      if (!obj[key]) {
        obj[key] = [];
      }

      if (paramName.match(/\[\d+\]$/)) {
        const index = /\[(\d+)\]/.exec(paramName)[1];
        obj[key][index] = paramValue;
      } else {
        obj[key].push(paramValue);
      }
    } else {
      if (!obj[paramName]) {
        obj[paramName] = paramValue;
      } else if (obj[paramName] && typeof obj[paramName] === "string") {
        obj[paramName] = [obj[paramName]];
        obj[paramName].push(paramValue);
      } else {
        obj[paramName].push(paramValue);
      }
    }
  }

  return obj;
};

//----------------------------------------------------------------//

bcl.u.replaceLastCharacterWithSelector = function (url, selector) {
  return url.slice(0, -1) + "--" + selector + "/";
};

//----------------------------------------------------------------//

bcl.u.addedSelectorInUrl = function (url, selector) {
  url = bcl.u.includes(url, "html") ? url.replace(".html", "." + selector + ".html") : url;
  url = !bcl.u.includes(url, "html") && url.slice(-1) === "/" ? bcl.u.replaceLastCharacterWithSelector(url, selector) : url;

  return url;
};

//----------------------------------------------------------------//

bcl.u.loadComponentsForInjectedHtml = function ($injectedNode) {
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  const componentsInHtml = Object.entries(Components).filter(([_, component]) =>
    component.isPresent({
      root: $injectedNode,
      ignoreForceImport: true,
    }),
  );
  BarceloComponents.init(Object.fromEntries(componentsInHtml), { root: $injectedNode, ignoreForceImport: false });
};

//----------------------------------------------------------------//

bcl.u.loadComponentByName = async function (componentName) {
  if (!bcl.c.manifest[componentName]) {
    const component = Components[componentName];
    await BarceloComponents.init({ [componentName]: component }, { ignoreForceImport: false, ignoreIsPresent: false });
  }
};

//----------------------------------------------------------------//

bcl.u.isDescendant = function (parent, child) {
  let node = child.parentNode;
  while (node != null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

//----------------------------------------------------------------//

bcl.u.isElementInView = function (element, fullyInView) {
  if (element) {
    const pageTop = window.scrollY;
    const pageBottom = pageTop + window.innerHeight;

    const elementTop = element.getBoundingClientRect().top + pageTop;
    const elementBottom = elementTop + element.offsetHeight;

    if (fullyInView === true) {
      return pageTop < elementTop && pageBottom > elementBottom;
    } else {
      return elementTop <= pageBottom && elementBottom >= pageTop;
    }
  }
};

//----------------------------------------------------------------//

bcl.u.getKeyByValue = function (obj, val) {
  return Object.keys(obj).find((key) => obj[key] === val);
};

//----------------------------------------------------------------//

bcl.u.findClosestNodeWithClass = function (startNode, targetClass) {
  const insideNode = startNode.closest("." + targetClass);
  if (insideNode) {
    return insideNode;
  }

  let currentNode = startNode.parentElement;
  while (currentNode !== null) {
    if (currentNode.classList.contains(targetClass)) {
      return currentNode;
    }
    currentNode = currentNode.parentElement;
  }

  return null;
};

bcl.u.getRoomPrice = function (roomData) {
  return roomData?.AmountConvertedFinal || roomData?.AmountWithTaxesFees || null;
};

bcl.u.calculateDecimalsByExponent = function (value, exponent) {
  return Math.round(value / Math.pow(10, exponent));
};

bcl.u.formatPriceDecimals = function (obj, basePrice = false) {
  if (!obj) {
    return;
  }
  obj = basePrice ? obj?.base : obj?.total;

  const priceObj = obj.converted || obj;
  const value = bcl.u.calculateDecimalsByExponent(priceObj.value, priceObj.exponent);
  return Math.round(value);
};

window.$body = (function () {
  if (bcl.u.mobile.iOS()) {
    return document.querySelector("body");
  } else {
    return document.querySelector("html, body");
  }
})();
